// extracted by mini-css-extract-plugin
module.exports = {"loader":"_splashScreen_loader__NIv1f","loading":"_splashScreen_loading__7CnvB"};